import { Mapper } from 'src/base/mapper'
import { SubscriptionDataTableTypeEntity } from 'src/data/entities/subscription.entity'
import { SubscriptionDataTableTypeModel } from 'src/domain/models/subscription.model'

export class SubscriptionDataTableMapper extends Mapper<
	SubscriptionDataTableTypeEntity,
	SubscriptionDataTableTypeModel
> {
	mapFrom(param: SubscriptionDataTableTypeEntity): SubscriptionDataTableTypeModel {
		return {
			subscriptionId: param.subscriptionId,
			total: param.total,
			productName: param.productName,
			planName: param.planName,
			status: param.status,
			companyName: param.companyName,
			dateNextBilling: param.dateNextBilling,
			dateStartOn: param.dateStartOn,
			dateExpired: param.dateExpired,
			dateUpdated: param.dateUpdated,
		}
	}

	mapTo(param: SubscriptionDataTableTypeModel): SubscriptionDataTableTypeEntity {
		return {
			subscriptionId: param.subscriptionId,
			total: param.total,
			productName: param.productName,
			planName: param.planName,
			status: param.status,
			companyName: param.companyName,
			dateNextBilling: param.dateNextBilling,
			dateStartOn: param.dateStartOn,
			dateExpired: param.dateExpired,
			dateUpdated: param.dateUpdated,
			statusName: null,
			discount: null,
			vatAmount: null,
			planDescription: null,
			dateLastBilling: null,
			dateTrialExpire: null,
			isRenew: null,
		}
	}
}
